module.exports = __webpack_public_path__ + "static/media/S (135).cf0dbaf9.jpg";